import React from 'react';
import { useDispatch } from 'react-redux';

import { AppDispatch } from '../../../store/store';
import { restoreContext } from '../store/contextSlice';

/**
 * DEC-S2-S01-06 — the server could not say whose space this is.
 *
 * Shown instead of either shell: a failed read is not "not in kid mode", and
 * guessing would put the Parent console in front of a child. Neutral on purpose,
 * because nobody here knows who is holding the device.
 */
const ContextUnavailable: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div role="alert" style={{ padding: 24, textAlign: 'center' }}>
      <p>No pudimos cargar tu cuenta en este momento.</p>
      <button type="button" className="btn" onClick={() => dispatch(restoreContext())}>
        Reintentar
      </button>
    </div>
  );
};

export default ContextUnavailable;
